







































import Vue from "vue";
import SwipeListContainer from "@/components/ui/SwipeListContainer.vue";
import ListItem from "@/components/ui/ListItem.vue";
import TableContainer from "@/components/ui/TableContainer.vue";
import InfiniteLoading, { StateChanger } from "vue-infinite-loading";

import { Meldung } from "@/types";
import ApiService from "@/services/ApiService";
import AlertService from "@/services/AlertService";
import { FilterParameter } from "@/types/FilterParameter";

/**
 * @OnSetOnRead set as read if clicked
 * @OnClick redirect to detail page
 */
export default Vue.extend({
  name: "MeldungenCard",
  components: {
    ListItem,
    SwipeListContainer,
    TableContainer,
    InfiniteLoading,
  },
  props: {
    filter: {
      type: Object as () => FilterParameter,
      default: undefined,
    },
  },
  data: function () {
    return {
      meldungen: [] as Meldung[],
      page: 1,
      loadingIdentifier: +new Date(),
    };
  },
  watch: {
    filter: {
      handler() {
        this.resetLoadingState();
      },
      deep: true,
    },
  },
  methods: {
    infiniteLoadingHandler(state: StateChanger) {
      ApiService.getMeldungen(this.page, this.filter)
        .then((res: Meldung[]) => {
          // combine meldung arrays
          this.meldungen = [...this.meldungen, ...res];
          // increae page for next loading
          this.page++;
          // call Infinite scoller if finish or more data can be loaded
          if (res.length) state.loaded();
          else state.complete();
        })
        .catch(() => state.error());
    },
    resetLoadingState() {
      this.page = 1;
      this.meldungen = [];
      // change the loading ifenditfier will force the InfiniteLoading Component to reload
      this.loadingIdentifier = +new Date();
    },
    onClick(meldung: Meldung) {
      if (meldung.info.id)
        this.$router.push({
          path: "/details/" + meldung.info.id,
        });
    },
    setAsRead(meldung: Meldung) {
      // if meldung isn't already read
      if (!meldung.actions.gelesen) {
        // if meldung is not a warning
        if (meldung.info.typId != 1)
          // set meldung as read
          ApiService.readMeldung(meldung.info.id).then(
            () => (meldung.actions.gelesen = 1)
          );
        // else decline set as read and show toast to inform user
        else AlertService.warning("Diese Meldung muss zuerst angesehen werden");
      }
    },
  },
});
